import React from "react";
import TurnausInfo from "./turnausInfo";
import Lauantai from "./lauantai";
import Sunnuntai from "./sunnuntai";
import Pukukopit from "./pukukopit";
import Kahvila from "./kahvila";
import Ruokailu from "./ruokailu";
import Lamaritutka from "./lamaritutka";
import GameChanger from "./gameChangerResult";
import GameChangerSun from "./gameChangerResultSun";
import LamaritutkaSun from "./lamaritutkaSun";

const Content = ({ isAdmin, activeTab }) => {
  return (
    <div>
      {activeTab === "turnausInfo" && <TurnausInfo />}
      {activeTab === "lauantai" && <Lauantai isAdmin={isAdmin} />}
      {activeTab === "sunnuntai" && <Sunnuntai isAdmin={isAdmin} />}
      {activeTab === "pukukopit" && <Pukukopit />}
      {activeTab === "kahvila" && <Kahvila />}
      {activeTab === "ruokailu" && <Ruokailu />}
      {activeTab === "lamaritutka" && <Lamaritutka />}
      {activeTab === "lamaritutkaSun" && <LamaritutkaSun />}
      {activeTab === "gameChangerResult" && <GameChanger />}
      {activeTab === "gameChangerResultSun" && <GameChangerSun />}
    </div>
  )
};

export default Content;
